module.exports = __webpack_public_path__ + "img/brands-bluebike.0ae59970.svg";